
import baseClaimForm from '@/mixins/baseClaimForm'
import moment from 'moment'
import state from '@/mixins/state'
import base from '@/mixins/base'

import axios from 'axios'

const MSG_TYPE_INITIAL = 0; const MSG_TYPE_INFO = 1; const MSG_TYPE_ERROR = 2

export default {
  mixins: [
    base,
    baseClaimForm,
    state
  ],
  components: {

  },
  data () {
    return {
      insuranceLineType: 1,
      // isPolicyholder: true

      apiUserMsg: null,

      apiMsg: {
        type: MSG_TYPE_INITIAL,
        text: ''
      }
    }
  },
  mounted () {
    if (this.claimForm.formReference == '') { this.setClaimFormReference({ formReference: this.newId() }) }

    if (this.claimForm.insuranceLine == '') { this.setInsuranceLineId({ insuranceLine: this.insuranceLineType }) }
  },
  // beforeRouteLeave (to, from, next) {
  //   this.saveClaimForm()
  //   next()
  // },
  computed: {
    // ---------------------------------------------------------//
    // Urls for this flavour of claim form
    // ---------------------------------------------------------//
    saveClaimFormUrl () {
      return this.baseUrl + '/api/v1/onlineclaim/standalone/partial'
    },
    submitClaimFormUrl () {
      return this.baseUrl + '/api/v1/onlineclaim/standalone/submit/'
    },
    isEmailConfirmed () {
      const { claimform } = this.$store.state;
      if (false) {
        console.log("DEBUG: isEmailConfirmed");
        console.log("claimform.hasOwnProperty(emailConfirmed) : ", claimform.hasOwnProperty("emailConfirmed"));
        console.log("typeof claimform[emailConfirmed] === boolean : ", typeof claimform["emailConfirmed"] === 'boolean');
      }

      if (claimform && 
        claimform.hasOwnProperty("emailConfirmed")) {
        if (typeof claimform["emailConfirmed"] === 'boolean') {
          return true; /*claimform["emailConfirmed"];*/
        }
      }
      return false;
    },
    isTelephoneConfirmed () {
      const { claimform } = this.$store.state;
      if (false) {
        console.log("DEBUG: isTelephoneConfirmed");
        console.log("claimform.hasOwnProperty(telephoneConfirmed) : ", claimform.hasOwnProperty("telephoneConfirmed"));
        console.log("typeof claimform[telephoneConfirmed] === boolean : ", typeof claimform["telephoneConfirmed"] === 'boolean');
      }
      if (claimform && 
        claimform.hasOwnProperty("telephoneConfirmed")) {
        if (typeof claimform["telephoneConfirmed"] === 'boolean') {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    // ---------------------------------------------------------//
    // Get the policy details from the server
    // ---------------------------------------------------------//
    lookupPolicy (number, dob, postcode, successPath, incidentDate) {
      this.isLoading = true

      let payload = {
        resellerId: this.resellerId,
        policyNumber: number,
        policyholderDOB: dob,
        policyholderPostcode: postcode,
        incidentDate
      }

      // axios.get( this.baseUrl + '/api/v1/standalonepolicy/' + number)
      axios.post(this.baseUrl + '/api/v1/standalonepolicy/getpolicy', payload)
        .then(response => {
          let apiRes = response.data

          if (apiRes.data) {
            this.setStandalonePolicy({ ...apiRes.data })

            // this.setPolicy({ number: this.standalonePolicy.number });
            this.setPolicy({ number: apiRes.data.number })

            let policyholder = this.standalonePolicy.policyholder
            if (policyholder) {
              this.setClaimantAndSavedEmail({
                title: policyholder.title,
                firstname: policyholder.firstname,
                lastname: policyholder.lastname,
                email: policyholder.emailAddress,
                // confirmEmail: null,
                mobile: policyholder.mobileNumber,
                dateOfBirth: policyholder.dateOfBirth,
                telephone: policyholder.telephoneNumber,
                occupation: 'NA',
                address: { ...policyholder.address },
                policyholder: this.isPolicyholder
              })
            }
            this.apiMsg = {
              type: MSG_TYPE_INITIAL,
              text: ''
            }

            var doi = moment(this.$store.state.claimform.claimForm.data.incident.dateOfIncident, 'YYYY-MM-DD').format('YYYY-MM-DD');
            var dateOfIncident = moment(doi, 'YYYY-MM-DD');
            var cvrStart = moment(apiRes.data.coverStartDate, 'YYYY-MM-DD');
            var cvrEnd = moment(apiRes.data.coverEndDate, 'YYYY-MM-DD');

            if (dateOfIncident.isBetween(cvrStart.format('YYYY-MM-DD'), cvrEnd.format('YYYY-MM-DD'), undefined, '[]')) {
              if (successPath) {
                this.$router.push(successPath)
              }
            } else {
              this.$router.push({ path: 'quoteconfirm' })
            }
            this.getUnderwriter(apiRes.data.underwriterId)
          } else {
            this.apiMsg = {
              type: MSG_TYPE_INFO,
              text: 'Please check your policy information and try again.'
            }
          }
        })
        .catch(error => {
          this.apiMsg = {
            type: MSG_TYPE_ERROR,
            text: 'There seems to be a problem.  Please try again later.'
          }
        })
        .finally(() => this.isLoading = false)
    },
    getPolicy (number, dob, postcode, successPath) {
      this.isLoading = true

      let payload = {
        resellerId: this.resellerId,
        policyNumber: number,
        policyholderDOB: dob,
        policyholderPostcode: postcode
      }

      // axios.get( this.baseUrl + '/api/v1/standalonepolicy/' + number)
      axios.post(this.baseUrl + '/api/v1/standalonepolicy/getpolicy', payload)
        .then(response => {
          let apiRes = response.data

          if (apiRes.data) {
            this.setStandalonePolicy({ ...apiRes.data })

            // this.setPolicy({ number: this.standalonePolicy.number });
            this.setPolicy({ number: apiRes.data.number })

            // let policyholder = this.standalonePolicy.policyholder
            // if (policyholder) {
            //   this.setClaimantAndSavedEmail({
            //     title: policyholder.title,
            //     firstname: policyholder.firstname,
            //     lastname: policyholder.lastname,
            //     email: policyholder.emailAddress,
            //     // confirmEmail: null,
            //     mobile: policyholder.mobileNumber,
            //     dateOfBirth: policyholder.dateOfBirth,
            //     telephone: policyholder.telephoneNumber,
            //     occupation: 'NA',
            //     address: { ...policyholder.address },
            //     policyholder: this.isPolicyholder
            //   })
            // }
            this.apiMsg = {
              type: MSG_TYPE_INITIAL,
              text: ''
            }              
          } else {
            this.apiMsg = {
              type: MSG_TYPE_INFO,
              text: 'Please check your policy information and try again.'
            }
          }
          if (successPath) {
            this.$router.push(successPath)
          }
        })
        .catch(error => {
          this.apiMsg = {
            type: MSG_TYPE_ERROR,
            text: 'There seems to be a problem.  Please try again later.'
          }
        })
        .finally(() => this.isLoading = false)
    },
    runFormValidation() {
      const createValidationItem = (id, name, result) => {
        return {
          id,
          name,
          result
        }
      }

      let validationResult = [];
      validationResult.push(createValidationItem(1,"policyLookup", this.claimformHasPolicyNumber));
      validationResult.push(createValidationItem(3,"confirmContact", this.isEmailConfirmed));
      validationResult.push(createValidationItem(5,"incidentTypes", this.claimformHasIncidentType));
      validationResult.push(createValidationItem(6,"aboutYou", this.claimformHasClaimantUKRes && this.claimformHasClaimantVATReg));
      validationResult.push(createValidationItem(8,"incidentDetails", this.claimformHasIncidentDetails));
      validationResult.push(createValidationItem(10,"gadgetList", this.claimformHasGadgets));
      validationResult.push(createValidationItem(13,"declaration", this.claimformHasDeclarations));
      return validationResult;
    },
    goToStage() {
      const debug = false;

      if (debug) {
        console.log("goToStage")
        console.log("this.claimFormStage : ", this.claimFormStage)
        console.log("runFormValidation : ", this.runFormValidation())
      }
      // check for all true and do nothing
      const formValidationResults = this.runFormValidation();
      const allPassed = formValidationResults.every((s) => s.result === true);
      if (allPassed) {
        return;
      }

      // or goto the first false...
      const sortedResults = formValidationResults.sort((a,b) => a.id - b.id);
      const firstIncomplete = sortedResults.find(o => o.result === false);
      if (debug) console.log("firstIncomplete : ", firstIncomplete)
      const getStageFromRoute = (route) => {
        let { path, name } = route;
        const id = path.slice(-1);
        return {id: parseInt(id), name}; 
      }
      if (debug) console.log("getStageFromRoute : ", getStageFromRoute(this.$route));
      const currentStage = getStageFromRoute(this.$route);
      if (firstIncomplete.id >= currentStage.id) {
        return;
      }
      let routerPath = `/makeaclaim/${firstIncomplete.id}`

      if (this.$route.path !== routerPath) {
        this.$router.push(routerPath);
      }
    }
  }
}
